
export interface CognitoConfig {
  region: string;
  userPoolId: string;
  clientId: string;
}

// Get configuration from environment variables or fallback to config file
export const getCognitoConfig = (): CognitoConfig => {
  return {
    region: import.meta.env.VITE_AWS_REGION || "us-west-1",
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || "us-west-1_zO74rLkYG",
    clientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID || "6o2kjuvg8ns89k5vehkdedrh9",
  };
};

export default getCognitoConfig();
